import Vue from 'vue';
import globalWin from '@/utils/globalWin';
function getReqFun(methodName, transParams) {
  const reqFun = function (url, postData = {}, config = {}) {
    return new Promise((resolve, reject) => {
      const reqData = postData && { ...postData };
      if (transParams) {
        reqData.params = postData;
      }
      if (globalWin.auth) {
        if (!config.headers) {
          config.headers = {};
        }
        const { appid, aid, d2 } =  globalWin.auth;
        config.headers = { ...config.headers,
          'X-Appid': appid,
          'X-Aid': aid,
          'X-D2': d2,
          'X-Tenant-Id': globalWin.kfuin,
        };
      }

      Vue.prototype.$ajax[methodName](`${url}`, reqData, config)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  return reqFun;
}

export default {
  get: getReqFun('get', true),
  post: getReqFun('post'),
};
